import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      setIsMobileMenuOpen(false);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-brand">
          <img 
            src="/brilhapiscinalogo.jpg" 
            alt="Brilha Piscina" 
            className="navbar-logo"
          />
        </div>
        
        <div className={`navbar-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <a href="#home" className="nav-link">Início</a>
          <a href="#services" className="nav-link">Serviços</a>
          <a href="#about" className="nav-link">Sobre</a>
          <a href="#contact" className="nav-link">Contato</a>
          <a 
            href="https://wa.me/5521966527607?text=Olá! Tenho interesse nos serviços da Brilha Piscina. Gostaria de solicitar um orçamento."
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Orçamento
          </a>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
